import React,{Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import * as actions from './../../actions';
import {Link} from 'react-router';
import { OffCanvas, OffCanvasMenu } from 'react-offcanvas';
import {DropdownButton} from 'react-bootstrap';
import $ from 'jquery';

export  class Header extends Component{
	constructor(props){
		super(props);
		this.state={
      status: '',
			keyword: '',
      cart_count:this.props.cart_updated_count,
      cart_count_update:0,
      isMenuOpened:false,
      aquacash:'',
      bookings:'',
      noty_count:'',
      menuItems:[],
		};

  this.getCartCount=this.getCartCount.bind(this);
  this.menuClick=this.menuClick.bind(this);
  this.dashboard=this.dashboard.bind(this);
  this.getMenuItems=this.getMenuItems.bind(this);
  }
  componentDidMount()
  {
      if(localStorage.token && localStorage.user_id)
      {
        this.getCartCount();
        this.dashboard();
      }
      this.getMenuItems();
      document.addEventListener('click',this.handleClickOutside.bind(this), true);
      //this.props.getcartcount();
  }
  getMenuItems()
  {
    var baseUrl='https://aquadeals.in/admin/web3/user/';
    var data1={from:'desktop_web',};
    var data2=JSON.stringify(data1);
    $.ajax({
        method:'POST',
        dataType:'json',
        url:baseUrl+'browse_categories',
        data:{req:data2},
        success:function(data)
        {
          if(data.status==='success')
          {
            this.setState({
                menuItems:data.categories,
            });
          }
        }.bind(this),
        error:function(err)
        {

        }
    });
  }
  componentWillUnmount()
  {
    this.props.clear_state();
    // document.removeEventListener('click', this.handleClickOutside.bind(this), true);
  }
  dashboard()
  {
    var baseUrl='https://aquadeals.in/admin/web3/user/';
    var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token};
    var data2=JSON.stringify(data1);
    $.ajax({
      method:'POST',
      dataType:'json',
      data:{req:data2},
      url:baseUrl+'dashboard',
      success:function(data)
      {
          if(data.status==='success')
          {
            this.setState({
              aquacash:data.aquacash,
              bookings:data.bookings,
              noty_count:data.notifications,
            });
          }
      }.bind(this),
      error:function(err)
      {
      }
    });
  }
  menuClick()
  {
    this.setState({
      isMenuOpened: !this.state.isMenuOpened,
    });
  }
  getCartCount()
  {
        var baseUrl='https://aquadeals.in/admin/web3/user/';
        var data1={from: 'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
        var data2=JSON.stringify(data1);
        $.ajax({
              method: 'POST',
              url: baseUrl+'cart_count',
              dataType:'json',
              data: {req:data2},
              success: function(data)
              {
                this.setState({
                    cart_count:data.cart_count,
                });
              }.bind(this),
              error: function(err)
              {
              
              }
        });
  }
  onFocus(event)
  {
    this.props.getcartcount();
    this.setState({
      status: 'focus',
      keyword: event.target.value,
    });
  }
  onChangeKey(event)
  {
    if(event.target.value.length > 2)
    {
      this.props.search_products(event.target.value);
    }
    else if(event.target.value.length === 0)
    {
      this.props.search_products('');    
    }

      this.setState({
        keyword: event.target.value
      })
  }
  onBlur()
  {  
    this.setState({
      status: 'unfocus'
    })
  }
  resetKey()
  {
    this.props.search_products('');
    this.setState({
      keyword:'',
    });
  }
  
  logout()
  {
    localStorage.clear();
    window.location.reload();
  } 
  
  handleClickOutside(event)
  {
    // alert("testing "+ event.target);
    const domNode = ReactDOM.findDOMNode(this);
    // alert("testing" + domNode)
    if (!domNode || !domNode.contains(event.target))
    {
        this.setState({
            isMenuOpened : false
        });
    }
    // if(this.state.isMenuOpened)
    // {
    //   this.setState({
    //     isMenuOpened:!this.state.isMenuOpened,
    //   })
    // }
    // else
    // {
    //   this.setState({
    //     isMenuOpened:false,
    //   })  
    // }
  }
  render(){ 
    // if(!this.props.cart_updated_count)
    // {
    //   this.getCartCount();
    // }
  $(document).on('mouseup',function (e)
  {
      var container = $('.search');
      var container_sub = $('.res');
      if (!container.is(e.target) // if the target of the click isn't the container...
          && container.has(e.target).length === 0) // ... nor a descendant of the container
      {
          container_sub.hide();
      }
      else
      {
      	container_sub.show();
      }
  }); 
  if(this.props.brands.length > 0 ){ var brands = (<h5 className="brand_hdr">Brands</h5>)} 
  if(this.props.products.length > 0 ){ var products = (<h5 className="brand_hdr">Products</h5>)}  
  if(this.props.categories)
  {
    if(this.props.categories.length > 0)
    {
        var categories = (<h5 className="brand_hdr">Categories</h5>)  
    }
  }
  var brands_list=this.props.brands.map(function(brand,index){
      return(
            <li key={index} onClick={()=>{location.reload();}}>
              <Link style={{textDecoration: 'none'}} className="brand_tlt" to={"/web/pdeals/"+brand.url_dtype_name+"/"+brand.url_brand_name+"/"+brand.id+"/"+brand.type+"/"+brand.dtype} >
                <img className="" alt="" src={'https://aquadeals.in/admin/assets/images/brand_icons/'+brand.logo} width="30px;"/>
                  <span>
                    {brand.category_name}
                  </span>
              </Link>
            </li>
         )
       }) ;  
  if(this.props.categories)
  {
      if(this.props.categories.length > 0)
      {
        var categories_list=this.props.categories.map(function(category,index){
        return(
              <li key={index} onClick={()=>{location.reload();}}>
                <Link style={{textDecoration: 'none'}} className="brand_tlt" to={"/web/pdeals/"+category.url_dtype_name+"/"+category.url_cat_name+"/"+category.id+"/"+category.type+"/"+category.dtype} >
                  <img className="" alt="" src={'https://aquadeals.in/admin/assets/images/icons/'+category.logo} width="30px;"/>
                    <span>
                      {category.category_name}
                    </span>
                </Link>
              </li>
           )
         }) ;  
      }
  }

  var product_list=this.props.products.map(function(product,index){
      return(
            <li key={index} onClick={()=>{location.reload();}}>
            <Link  style={{textDecoration: 'none'}} className="brand_tlt" to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.id+"/"+product.deal_id} > 
               <img className="" alt="" src={'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/'+product.logo} width="30px;"/>
                <span>
                    {product.category_name}
                 </span>
              </Link>
            </li>
         )
    }) ;      

  var aut_status = '';
  if(localStorage.token)
  {
      aut_status = <a id="cursor" onClick={this.logout.bind(this)}>LOGOUT</a>;
  }
  else
  {
      aut_status = <Link to="/web/login">LOGIN</Link>;
  }
  var menuItems=this.state.menuItems.map(function(data,index){
    return(
        <li id={index} onClick={()=>{location.reload();}}><Link to={data.redirect_url}>{data.dtype}</Link></li>
    );
  })
		return(
      <div className="web_deals web_header_page">
          <section className="indx_hdr hm_hdr">
            <div className="inx_nav">
                <nav className="navbar navbar-default">
                    <div className="container">
                      <div className="row">
                          <div className="col-md-4 col-lg-4 col-sm-4 col-xs-6">
                              <ul className="ul-style-none">
                                  <li style={{float:'left',width:'15%',marginTop:'20px'}}><a className="hm_menu_btn" style={{color:'#666'}} onClick={()=>{this.menuClick()}}><i className="glyphicon glyphicon-menu-hamburger"></i></a></li> 
                                  <li>
                                      <Link className="navbar-brand indx_logo" to={"/web/home"}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/abt_logo.png'} title="AquaDeals" alt="AquaDeals" /></Link>
                                  </li>
                                  <li>
                                      <DropdownButton title="Browse Categories" className="cat-drop" id="drp_btn">
                                          {/*<li id="1"><Link to="/web/seed">Seed</Link></li>
                                          <li id="2" onClick={()=>{location.reload();}}><Link to={"/web/pdeals/feed/all/2"} >Feed</Link></li>
                                          <li id="3" onClick={()=>{location.reload();}}><Link to={"/web/pdeals/healthcare/all/4"} >Health Care</Link></li>
                                          <li id="4" onClick={()=>{location.reload();}}><Link to={"/web/pdeals/machinery-farm-equipment/all/3"}>Machinery & Farm Equipment</Link></li>*/}
                                          {menuItems}
                                          <li id="5"><a href="http://blog.aqua.deals" target="_blank" >Blog</a></li>
                                      </DropdownButton>
                                  </li>
                              </ul>
                          </div>
                          <div className="col-md-4 col-lg-4 col-sm-4 col-xs-6 pull-right"> 
                              <ul className="nav navbar-nav navbar-right">
                                  <li className="abt_cls">
                                    <a className="web_cart_btn" title="My Cart" href="/web/mycart">
                                          <img alt=" " src={'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png'} />
                                          {this.props.cart_updated_count==='0' && this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "web_cart_count1" : "web_cart_count"}>{this.state.cart_count}</span> : ''}
                                          {this.props.cart_updated_count ?  <span className={this.props.cart_updated_count > 9 ? "web_cart_count1" : "web_cart_count"}>{this.props.cart_updated_count}</span> : ''}
                                      </a>
                                  </li>
                                  <li className="abt_cls"><Link title="ABOUT US" to={"/web/aboutus"} >ABOUT US</Link></li>
                                  {/*<li className="abt_cls"><Link to={'/web/downloads'} title="DOWNLOADS">DOWNLOADS</Link></li>*/}
                                  <li className="abt_cls">{aut_status}</li>
                                  <li><Link to={'/web/downloads'} title="Download AquaDeals Mobile App" className="dwnld_app">Download App</Link></li>
                              </ul>
                          </div>
                          <OffCanvas width={250} transitionDuration={300} isMenuOpened={this.state.isMenuOpened} position={"left"}>
                              <OffCanvasMenu className="web_side_menu" >
                                   {/*<div className="side_bar_prfil">
                                      <div className="side_bar_prfil_pic">
                                        <Link to={"/web/profile"}><Image src={'https://aquadeals.in/admin/assets/images/pro_pics/'+this.state.pro_pic} alt="" circle width="100%" height="100%" style={{marginLeft:'0px',marginTop:'0px'}} /></Link>
                                      </div>
                                      <h5>{this.state.name ? this.state.name : 'Welcome'}</h5>
                                      {this.state.email ? <h6>{this.state.email}</h6> : ''}
                                   </div>*/}
                                   <div className="web_side_bar_menu">
                                        <ul>
                                            <li><Link to={'/web/myaquacash'} title="My AquaCash"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/nav_aquacash.png'} alt=""/></i>My Aquacash{this.state.aquacash ? <span className="nav_menu_right">&#8377;{this.state.aquacash}</span>: ''}</Link></li>
                                            <li><Link to={'/web/myorders'} title="My Orders"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/nav_my_bookings.png'} alt=""/></i>My Orders{this.state.bookings ? <span className="nav_menu_right">{this.state.bookings}</span> : ''}</Link></li>
                                            <li><Link to={'/web/mycart'} title="My Cart"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/cart_icon.png'} alt=""/></i>My Cart {this.state.cart_count >0 ? <span className="nav_menu_right">{this.state.cart_count}</span>: ''}</Link></li>
                                            {/*{this.state.smart_cart_flag===1 ? <li><Link to={'/web/smartcart'} title="Smart Cart"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/cart_icon.png'} alt=""/></i>Smart Cart</Link></li> : ''}*/}
                                            <li><Link to={"/web/profile"} title="My Profile"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/home_my_profile.png'} alt=""/></i>My Profile</Link></li>
                                            <li><Link to={'/web/notifications'} title="Notifications"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/home_notification_hdr.png'} alt=""/></i>Notifications {this.state.noty_count > 0 ? <span className="nav_menu_right">{this.state.noty_count}</span> : ''}</Link></li>
                                            <li><Link to={'/web/offerszone'} title="Offers Zone"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/nav_offers.png'} alt=""/></i>Offers Zone</Link></li>
                                            <li><Link to={'/web/share_earn'} title="Share & Earn"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/nav_refer_earn.png'} alt=""/></i>Share & Earn</Link></li>
                                            <li><Link to="/web/customer_care" title="Customer Care"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/nav_customer_care.png'} alt=""/></i>Customer Support</Link></li>
                                            <li><Link to="/web/aboutus" title="About Us"><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/nav_aboutus.png'} alt=""/></i>About Us</Link></li>
                                            <li><a href="http://blog.aqua.deals" title="AquaDeals Blog" target="_blank"><i><img src={'https://aquadeals.in/admin/assets/mob-assets/blogger-logo.png'} alt=""/></i>Blog</a></li>
                                        </ul>
                                  </div>
                              </OffCanvasMenu>
                        </OffCanvas>
                          <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                              <div className="srch_br search">
                                  <form className="navbar-form navbar-left indx_srch">
                                    <div className="form-group">
                                      <input type="text" ref="keyword" onChange={this.onChangeKey.bind(this)} onFocus={ this.onFocus.bind(this) }  onBlur={ this.onBlur.bind(this) } value={this.state.keyword} className="form-control" placeholder="Search for Aquaculture products, brands and more" />
                                    </div>
                                    <button type="submit" className="btn btn-default"><i className="glyphicon glyphicon-search"></i></button>
                                  </form>
                                  <div className="res ressrch_box" style={{maxHeight: 400+'px',position: 'absolute',  left: 0,overflowX: 'hidden', margin:0+' auto',textDecoration: 'none',top: 45+'px', display: 'none',zindex: 9999}}>
                                      <div>{brands}</div>
                                      <ul style={{paddingLeft : 15+'px'}}>
                                        {brands_list}
                                      </ul>
                                      <div>{products}</div>
                                      <ul style={{paddingLeft : 15+'px'}}>
                                          {product_list}
                                      </ul>
                                      <div>{categories}</div>
                                      <ul style={{paddingLeft : 15+'px'}}>
                                        {categories_list}
                                      </ul>                
                                  </div>
                              </div>
                          </div>
                      </div>
                    </div>
                </nav>
            </div>
            <div className="clr">&nbsp;</div>
          </section>
          </div>
       	);
      } 
  }


function mapStateToProps(state){
    return {
        search:state.posts.search,
        brands:state.posts.brands,
        products:state.posts.products,
        trendings:state.posts.trendings,
        categories:state.posts.categories,
        cart_count:state.posts.cart_count,
        cart_status: state.posts.cart_status,
    }
}

export default connect(mapStateToProps,actions)(Header);



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Header.js
 **/